import MODULAR_VS from './shaders/modular-vertex.glsl';
import MODULAR_FS from './shaders/modular-fragment.glsl';
export { registerShaderModules, setDefaultShaderModules, getDefaultShaderModules } from './lib/resolve-modules';
export { assembleShaders, createShaderHook, createModuleInjection, resetGlobalShaderHooks } from './lib/assemble-shaders';
export { combineInjects } from './lib/inject-shader';
export { normalizeShaderModule } from './lib/shader-module';
export { getQualifierDetails, getPassthroughFS, typeToChannelSuffix, typeToChannelCount, convertToVec4 } from './utils/shader-utils';
export * from './modules';
export var MODULAR_SHADERS = {
  vs: MODULAR_VS,
  fs: MODULAR_FS,
  uniforms: {}
};
//# sourceMappingURL=index.js.map